import dayjs from "dayjs";
import { LEAVE_STATUS, LEAVE_TYPE } from "../../constants/booking";

export function getAdminLeaveDates(leaveDays) {
  if (!Array.isArray(leaveDays)) return [];
  return leaveDays.map((day) => day.date).filter(Boolean);
}

export function formatAdminLeaveDates(leaveDays) {
  const dates = getAdminLeaveDates(leaveDays);
  if (!dates.length) return "-";
  return dates.map((date) => dayjs(date).format("DD MMM YYYY")).join(", ");
}

export function getAdminLeaveReason(row) {
  if (row?.reason) return row.reason;
  const firstShiftLeave = row?.leaveDays?.[0]?.shiftLeaves?.[0];
  return firstShiftLeave?.reason ?? null;
}

export function getAdminLeaveReasonDescription(row) {
  if (row?.reasonDescription) return row.reasonDescription;
  const firstShiftLeave = row?.leaveDays?.[0]?.shiftLeaves?.[0];
  return firstShiftLeave?.reasonDescription ?? null;
}

export function getAdminLeaveShiftCount(leaveDays) {
  if (!Array.isArray(leaveDays)) return 0;
  return leaveDays.reduce(
    (sum, day) => sum + (Array.isArray(day.shiftLeaves) ? day.shiftLeaves.length : 0),
    0
  );
}

export function canAdminDecideLeaveRequest(request) {
  return (
    request?.type === LEAVE_TYPE.SICK && request?.status === LEAVE_STATUS.PENDING
  );
}
